// Function maps all attributes
// Eg.
// `mapFuncAttrsToObject("name", "age", "dob", "gender", "ssn", "par")`
// creates function
// const fn = (name, age, dob, gender, ssn, par) => {
//   return {
//     name: name,
//     age: age,
//     dob: dob,
//     gender: gender,
//     ssn: ssn,
//     par: par
//   }
// }

export const mapFuncAttrsToObject =
  (...arr) =>
    (...args) =>
      arr.reduce((acc, value, index) => ({
        ...acc,
        [value]: args[index]
      }), {})
